import { memo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from 'app/fuse-layouts/shared-components/LanguageSwitcher';
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu';
import chevronIcon from './icons/chevron.svg';
import downIcon from './icons/down.svg';
import helpIcon from './icons/help.svg';
import bellIcon from './icons/bell.svg';

function JobsTopBar() {
  const { t } = useTranslation('navigation');

  return (
    <header className="jobs-topbar">
      <Link className="jobs-topbar-crumb" to="/dashboard">
        {t('WORKSPACE', { defaultValue: 'Workspace' })}
      </Link>
      <img src={chevronIcon} alt="" />
      <span className="jobs-topbar-current">{t('JOBS')}</span>
      <span className="jobs-topbar-spacer" />
      <div className="jobs-topbar-lang">
        <LanguageSwitcher />
        <img src={downIcon} alt="" />
      </div>
      <button
        type="button"
        className="jobs-topbar-icon"
        aria-label={t('HELP', { defaultValue: 'Help' })}
        onClick={() => window.open('https://www.youtube.com/channel/UCsIaBjzrNMCDpqWQ5dLmhzA')}
      >
        <img src={helpIcon} alt="" />
      </button>
      <button
        type="button"
        className="jobs-topbar-icon"
        aria-label={t('NOTIFICATIONS', { defaultValue: 'Notifications' })}
      >
        <img src={bellIcon} alt="" />
      </button>
      <UserMenu />
      <img src={downIcon} alt="" />
    </header>
  );
}

export default memo(JobsTopBar);
